import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UIkit'

export const useReviewStyles = makeStyles(theme => ({
  container: {
    border: `1px solid ${GRAY_COLORS[300]}`,
    padding: '8px 16px',
    borderRadius: 16,
    marginBottom: 14
  },
  buttonLike: {
    border: `1px solid ${GRAY_COLORS[300]}`,
    borderRadius: 8,
    height: 50,
    width: 50
  }
}))
